export default __webpack_public_path__ + "static/media/android_step_2_Cn.d58cf9db.jpg";